export default {
  adult: 'The field :attribute must correspond to a person of more than 18 years.',
  after: {
    custom: 'The :attribute must be a date after :date.',
    today: 'The :attribute must be a date after today.'
  },
  afterOrEqual: {
    custom: 'The :attribute must be a date after or equal to :date.',
    today: 'The :attribute must be a date after or equal to today.'
  },
  alpha: 'Le champ :attribute doit contenir uniquement des lettres.',
  alphaLower: 'Le champ :attribute doit contenir uniquement des lettres minuscules.',
  alphaUpper: 'Le champ :attribute doit contenir uniquement des lettres majuscules.',
  alphaUpperNum: 'Le champ :attribute doit contenir uniquement des chiffres et des lettres majuscules.',
  alphaDash: 'Le champ :attribute doit contenir uniquement des lettres et des tirets.',
  alphaNumeric: 'Le champ :attribute doit contenir uniquement des chiffres et des lettres.',
  alphaSpace: 'Le champ :attribute doit contenir uniquement des lettres et des espaces.',
  before: {
    custom: 'The :attribute must be a date before :date.',
    today: 'The :attribute must be a date before today.'
  },
  beforeOrEqual: {
    custom: 'The :attribute must be a date before or equal to :date.',
    today: 'The :attribute must be a date before or equal to today.'
  },
  dateBetween: 'Le champ :attribute doit être une date comprise entre le :date (:first_inclusion) et le :second_date (:second_inclusion).',
  dateEquals: {
    custom: 'The :attribute must be a date equal to :date.',
    today: 'The :attribute must be a date equal to today.'
  }, // No Messages for email
  // email: 'Le champ :attribute doit être une adresse email valide.',
  greaterThan: {
    number: 'La valeur de :attribute doit être supérieure à :number.',
    string: 'Le texte de :attribute doit contenir plus de :number caractères.',
    array: 'Le tableau :attribute doit contenir plus de :number éléments'
  },
  greaterThanOrEqual: {
    number: 'La valeur de :attribute doit être supérieure ou égale à :number.',
    string: 'Le texte de :attribute doit contenir au moins :number caractères.',
    array: 'Le tableau :attribute doit contenir au moins :number éléments'
  },
  imei: 'Le champ :attribute doit être un numéro imei valide',
  lessThan: {
    number: 'La valeur de :attribute doit être inférieure à :number.',
    string: 'Le texte de :attribute doit contenir moins de :number caractères.',
    array: 'Le tableau :attribute doit contenir moins de :number éléments.'
  },
  lessThanOrEqual: {
    number: 'La valeur de :attribute doit être inférieure ou égale à :number.',
    string: 'Le texte de :attribute doit contenir au plus :number caractères.',
    array: 'Le tableau :attribute doit contenir au plus :number éléments'
  },
  numeric: 'Le champ :attribute doit contenir un nombre.', // No Messages for phoneNumber
  // phoneNumber: 'Le champ :attribute doit être un numéro de téléphone valide.',
  same: 'Les champs :other et :attribute doivent être identiques.',
  size: {
    number: 'La valeur de :attribute doit être :number.',
    string: 'Le texte de :attribute doit contenir :number caractères.',
    array: 'Le tableau :attribute doit contenir exactement :number éléments'
  },
  url: 'Le champ :attribute doit être un URL valide.'
}
